<template>
  <div
    class="d-flex flex-column px-0"
    :class="modeViewGame === 'theater' ? 'py-6' : 'container'"
    style="overflow: none !important"
  >
    <!-- Back Button / Title -->
    <div class="mx-auto" style="width: 100%; max-width: 1100px">
      <div class="d-flex align-center mt-2 mb-4">
        <v-btn icon @click="goBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="ml-4" style="width: 100%">
          <v-skeleton-loader
            v-if="!currentGameData"
            class="pt-2 ma-0"
            width="150px"
            type="text"
          ></v-skeleton-loader>
          <span
            v-else
            :class="$vuetify.breakpoint.smAndDown ? 'text-body-1' : 'text-h5'"
          >
            {{ currentGameData.title_game }}
          </span>
        </div>
      </div>
    </div>

    <!-- Game Iframe / Footer Game -->
    <div
      class="mx-auto d-flex flex-column align-center"
      style="width: 100%; height: 100%; overflow: none; position: relative"
    >
      <MobileGame
        v-if="$vuetify.breakpoint.mobile"
        :loading="loading"
        :gameUrl="gameUrl"
        :gameData="currentGameData"
        :status="status"
        @fetchGame="fetchGame"
      />

      <DesktopGame
        v-else
        :loading="loading"
        :gameUrl="gameUrl"
        :gameData="currentGameData"
        :status="status"
      />

      <!-- Games Related -->
      <div
        class="mx-auto d-flex flex-column justify-space-between"
        style="width: 100%; max-width: 1100px"
      >
        <GridHomeCategory
          v-if="relatedGames.length > 0"
          :relatedGames="relatedGames"
          :providers="providers"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DesktopGame from "./DesktopGame.vue";
import MobileGame from "./MobileGame.vue";
import GridHomeCategory from "../GridHomeCategory.vue";

export default {
  props: ["providers", "games"],
  components: { DesktopGame, MobileGame, GridHomeCategory },
  data: () => ({
    loading: true,
    gameUrl: "",
    status: null,
  }),

  created() {
    // Reset no modo de visualização do Game que está sendo usado nos botões
    // dentro dos componentes
    this.$store.commit("setModeViewGame", "");

    if (!this.logged) {
      this.loading = false;
      return;
    }

    this.refreshBalance();

    if (this.$vuetify.breakpoint.mobile) {
      this.loading = false;

      if (this.$route.query.firstViewGame) {
        const splitFullPath = this.$route.fullPath.split("&firstViewGame=true");
        const removeQueryUrl = splitFullPath[0] + splitFullPath[1];

        this.$router.replace({ path: removeQueryUrl });

        setTimeout(() => {
          this.fetchGame();
        }, 1000);
      }
    } else {
      this.fetchGame();
    }
  },

  watch: {
    "$route.params.gameId"() {
      if (this.$route.query.firstViewGame) {
        const splitFullPath = this.$route.fullPath.split("&firstViewGame=true");
        const removeQueryUrl = splitFullPath[0] + splitFullPath[1];

        this.$router.replace({ path: removeQueryUrl });

        setTimeout(() => {
          this.fetchGame();
        }, 1000);
      }

      this.status = null;

      if (this.$vuetify.breakpoint.mobile) return;

      if (this.logged) {
        this.loading = true;
        this.$router.go();
      }

      this.$nextTick(() => {
        this.$vuetify.goTo(0);
      });
    },
    logged(val) {
      if (val) {
        if (this.$vuetify.breakpoint.mobile) {
          this.loading = false;

          if (this.$route.query.firstViewGame) {
            const splitFullPath = this.$route.fullPath.split(
              "&firstViewGame=true"
            );
            const removeQueryUrl = splitFullPath[0] + splitFullPath[1];

            this.$router.replace({ path: removeQueryUrl });

            setTimeout(() => {
              this.fetchGame();
            }, 1000);
          } else {
            this.fetchGame();
          }
        } else {
          this.fetchGame();
        }
      } else {
        // this.$router.go();
        document.querySelectorAll("iframe").forEach((elem) => {
          elem.parentNode.removeChild(elem);
        });
      }
    },
    currentGameData(val) {
      if (val) {
        document.title = `${this.$t("newCasino.pageTitle.game", {
          game: val.title_game,
        })} - ${this.$store.state.operators.operator_name}`;
      }
    },
  },

  computed: {
    currentGameData() {
      const currentGameId = this.$route.params.gameId;

      const indexCurrentGame = this.games.findIndex(
        (game) => game.game_id === currentGameId
      );

      return this.games[indexCurrentGame];
    },

    relatedGames() {
      if (!this.currentGameData) {
        return [];
      }

      const relatedGamesByTheme = [];

      for (let i = 0; i < this.games.length; i++) {
        if (this.games[i].theme_game === this.currentGameData.theme_game) {
          if (
            this.games[i].game_id === this.currentGameData.game_id ||
            relatedGamesByTheme.find(
              (game) => game.game_id === this.games[i].game_id
            )
          )
            continue;

          relatedGamesByTheme.push(this.games[i]);

          if (relatedGamesByTheme.length === 12) break;
        }
      }

      return relatedGamesByTheme;
    },

    modeViewGame() {
      return this.$store.state.modeViewGame;
    },

    logged() {
      return this.$store.state.logged.status;
    },
  },

  methods: {
    refreshBalance() {
      this.$axios.get("/player/online/bank/balanceOnline").then((res) => {
        this.$store.commit("setCash", res.data.dados.balance);
        this.$store.commit("setBonus", {
          value: res.data.dados.balance_bonus,
          status: res.data.dados.balance_bonus_status,
        });
        this.$store.commit("setAvailableBalance", res.data.dados.available_balance);
        this.$store.commit("setRestrictedBalance", res.data.dados.restricted_balance);
      });
    },
    goBack() {
      this.$router.go(-1);
    },

    async fetchGame() {
      // if (this.loading) return;
      if (!this.logged) return;

      // const path = this.$route.path + `?demo=${this.$route.query.demo}`;
      const path = this.$route.path;

      // Atualizar página ao requisitar Game
      this.$nextTick(() => {
        this.$vuetify.goTo(0);
      });

      this.status = null;
      this.loading = true;
      this.gameUrl = "";

      if (!this.$store.state.userIp) {
        const res = await fetch("https://api.ipify.org?format=json");
        const { ip } = await res.json();
        this.$store.commit("setIp", ip);
        this.$axios.defaults.headers.ip = ip;
      }

      this.$axios
        .post(
          "/player/online/casino/sessions",
          this.$formdata({
            client_type: this.$vuetify.breakpoint.mobile ? "mobile" : "desktop",
            game_id: this.$route.params.gameId,
            casino_type: this.$route.params.casinoType,
          })
        )
        .then((res) => {
          const { name_game } = res.data.dados.game;
          const { game_url } = res.data.dados.data.launch_options;

          this.gameUrl = game_url;

          this.loading = false;

          this.$nextTick(() => {
            this.gameSetup(res.data.dados.data.launch_options);
          });

          document.title = `${this.$t("newCasino.pageTitle.game", {
            game: name_game,
          })} - ${this.$store.state.operators.operator_name}`;
        })
        .catch((err) => {
          this.status = err.response ? err.response.status : 400;

          if (this.status === 401) {
            delete this.$axios.defaults.headers.common[
              "Application-Authorization"
            ];

            this.$logout();

            this.$root.$emit("openUnloggedDialog", {
              redirectUrl: path,
            });
          }
        })
        .finally(() => {
          if (this.$vuetify.breakpoint.mobile) {
            // sem o timeout, o botão fica disponível pra click enquanto o navegador está levando ele pra o jogo
            setTimeout(() => {
              this.loading = false;
            }, 650);
          } else {
            this.loading = false;
          }
        });
    },

    toLobby() {
      if (this.$route.name === "casinoLobby") return;

      this.$router.push({
        name: "casinoLobby",
      });
    },

    gameSetup({ game_url, strategy }) {
      const gameLaunchOptions = { target_element: "game_wrapper" };

      gameLaunchOptions["launch_options"] = {
        game_url,
        strategy: this.$vuetify.breakpoint.mobile ? "redirect" : strategy,
      };

      const success = function(gameDispatcher) {
        // eslint-disable-next-line no-console
        console.log({ success: gameDispatcher });
      };

      const error = function(error) {
        // eslint-disable-next-line no-console
        console.log({ error });
      };

      window.sg.launch(gameLaunchOptions, success, error);
    },
  },
};
</script>
